export default function (props: any) {
    const { stroke = 'white' } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            // style={{ background: stroke === 'white' ? '#000' : '#fff' }}
            {...props}
        >
            <path d="M8.5 1H1V18.5H18.5V11" stroke={stroke} strokeWidth="1.125" strokeLinecap="round" />
            <path
                d="M5.26894 13.4356C5.04927 13.6552 5.04927 14.0114 5.26894 14.2311C5.48861 14.4507 5.84476 14.4507 6.06443 14.2311L5.26894 13.4356ZM19.0625 0.99998C19.0625 0.689319 18.8107 0.43748 18.5 0.43748H13.4375C13.1269 0.43748 12.875 0.689319 12.875 0.99998C12.875 1.31064 13.1269 1.56248 13.4375 1.56248H17.9375V6.06248C17.9375 6.37314 18.1894 6.62498 18.5 6.62498C18.8107 6.62498 19.0625 6.37314 19.0625 6.06248V0.99998ZM6.06443 14.2311L18.8978 1.39773L18.1023 0.602232L5.26894 13.4356L6.06443 14.2311Z"
                fill="white"
            />
        </svg>
    );
}
